/* ==========================================================================
   SCUFFERS — page produit
   Miniatures verticales, zoom, bascule d'univers, barre d'achat mobile.
   Chargé uniquement par la section produit ; le formulaire de variantes
   et l'ouverture des panneaux restent gérés par scf-theme.js.
   ========================================================================== */
(function () {
  'use strict';

  var BUREAU = '(min-width: 1024px)';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }
  function bureau() { return window.matchMedia(BUREAU).matches; }

  /* ---------- piste visible selon l'univers ---------- */
  function pisteActive(galerie) {
    var pistes = $$('[data-galerie-piste]', galerie);
    for (var i = 0; i < pistes.length; i++) {
      if (!pistes[i].hidden) return pistes[i];
    }
    return pistes[0];
  }

  /* ---------- miniatures ---------- */
  function initVignettes(galerie) {
    var boite = $('[data-vignettes]', galerie);
    if (!boite) return;
    var observateur = null;

    function construire() {
      var piste = pisteActive(galerie);
      if (!piste) return;
      var vues = $$('[data-galerie-vue]', piste);
      boite.innerHTML = '';
      vues.forEach(function (vue, n) {
        var src = vue.querySelector('img');
        if (!src) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'scf-vignette' + (n === 0 ? ' est-actif' : '');
        b.setAttribute('aria-label', String(n + 1));
        var i = document.createElement('img');
        i.src = src.currentSrc || src.src;
        i.alt = '';
        i.loading = 'lazy';
        i.draggable = false;
        b.appendChild(i);
        b.addEventListener('click', function () {
          if (glisse) return;
          vue.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        boite.appendChild(b);
      });
      surveiller(vues);
    }

    /* La vue centrale pilote la miniature active. Le seuil est resserré
       en haut et en bas pour qu'une seule vue soit candidate à la fois :
       sinon deux miniatures s'allument sur les images courtes. */
    function surveiller(vues) {
      if (observateur) observateur.disconnect();
      if (!window.IntersectionObserver) return;
      observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          var n = vues.indexOf(e.target);
          $$('.scf-vignette', boite).forEach(function (v, i) {
            v.classList.toggle('est-actif', i === n);
          });
          var actif = boite.children[n];
          if (actif) {
            var cible = actif.offsetTop - (boite.clientHeight / 2) + (actif.offsetHeight / 2);
            boite.scrollTo({ top: cible, behavior: 'smooth' });
          }
        });
      }, { root: null, rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      vues.forEach(function (v) { observateur.observe(v); });
    }

    /* Défilement des miniatures à la souris. Un déplacement de plus de
       cinq pixels annule le clic : sans ce garde-fou, tout glissement
       finit par une navigation involontaire. */
    var enfonce = false, glisse = false, departY = 0, departScroll = 0;
    on(boite, 'mousedown', function (e) {
      enfonce = true; glisse = false;
      departY = e.pageY; departScroll = boite.scrollTop;
      boite.style.scrollBehavior = 'auto';
    });
    on(boite, 'mousemove', function (e) {
      if (!enfonce) return;
      var d = e.pageY - departY;
      if (Math.abs(d) > 5) glisse = true;
      boite.scrollTop = departScroll - d;
    });
    on(document, 'mouseup', function () {
      enfonce = false;
      boite.style.scrollBehavior = '';
      setTimeout(function () { glisse = false; }, 0);
    });
    on(boite, 'mouseleave', function () { enfonce = false; });

    construire();
    galerie.addEventListener('scf:univers', construire);
  }

  /* ---------- bascule d'univers ---------- */
  function initBascule(galerie) {
    var bloc = $('[data-bascule-genre]', galerie);
    if (!bloc) return;
    var champ = $('[data-bascule-genre-champ]', bloc);
    var libelles = $$('.scf-bascule-genre__lib', bloc);
    var CLE = 'scf_univers';

    function appliquer(genre, memoriser) {
      $$('[data-galerie-piste]', galerie).forEach(function (p) {
        p.hidden = p.getAttribute('data-univers') !== genre;
      });
      libelles.forEach(function (l) {
        l.classList.toggle('est-actif', l.getAttribute('data-genre') === genre);
      });
      if (champ) champ.checked = genre === 'femme';
      var cadre = $('[data-galerie-cadre]', galerie);
      if (cadre) cadre.scrollTop = 0;
      if (memoriser) { try { localStorage.setItem(CLE, genre); } catch (e) {} }
      galerie.dispatchEvent(new CustomEvent('scf:univers'));
    }

    on(champ, 'change', function () { appliquer(champ.checked ? 'femme' : 'homme', true); });
    libelles.forEach(function (l) {
      on(l, 'click', function () { appliquer(l.getAttribute('data-genre'), true); });
    });

    var initial = 'homme';
    try { initial = localStorage.getItem(CLE) || 'homme'; } catch (e) {}
    var param = new URLSearchParams(window.location.search).get('univers');
    if (param === 'homme' || param === 'femme') initial = param;
    appliquer(initial, false);
  }

  /* ---------- zoom ---------- */
  function initZoom(galerie) {
    if (!galerie.hasAttribute('data-zoom')) return;
    var modale = document.getElementById('scf-zoom');
    if (!modale) return;
    var image = $('[data-zoom-image]', modale);

    on(galerie, 'click', function (e) {
      if (!bureau()) return;
      var vue = e.target.closest('[data-galerie-vue]');
      if (!vue) return;
      e.preventDefault();
      var marque = vue.querySelector('[data-plein]');
      var img = vue.querySelector('img');
      image.src = (marque && marque.getAttribute('data-plein')) || (img && img.src) || '';
      image.style.transform = 'scale(1)';
      if (window.scfPanneaux) window.scfPanneaux.ouvrir(modale);
    });

    /* Loupe : l'origine de la transformation suit le pointeur, ce qui
       évite de recalculer une position absolue à chaque déplacement. */
    on(image, 'mousemove', function (e) {
      var r = image.getBoundingClientRect();
      image.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' +
        ((e.clientY - r.top) / r.height * 100) + '%';
      image.style.transform = 'scale(2.2)';
    });
    on(image, 'mouseleave', function () { image.style.transform = 'scale(1)'; });
  }

  /* ---------- barre d'achat mobile ---------- */
  function initBarre() {
    var barre = $('[data-barre-achat]');
    if (!barre) return;
    var panneau = $('[data-barre-panneau]');
    var voile = $('[data-barre-voile]');
    var forme = document.getElementById(barre.getAttribute('data-forme-id'));
    if (!forme) return;

    var onglets = $$('[data-barre-onglet]', barre);
    var ouvert = null;

    function cible(nom) { return $('[data-barre-cible="' + nom + '"]', panneau); }

    /* Les sélecteurs du panneau sont des clones vivants : cliquer une
       taille dans le panneau rejoue le clic sur le bouton d'origine, donc
       toute la logique de variante reste dans scf-theme.js. */
    function peupler() {
      var t = cible('taille');
      if (t) {
        t.innerHTML = '';
        $$('.scf-taille', forme).forEach(function (src) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = src.className;
          b.textContent = src.textContent.trim();
          b.addEventListener('click', function () {
            src.click();
            var val = $('[data-barre-taille]', barre);
            if (val) val.textContent = src.textContent.trim();
            fermer();
          });
          t.appendChild(b);
        });
      }
      var c = cible('couleur');
      var source = $('.scf-couleurs');
      if (c && source) { c.innerHTML = ''; c.appendChild(source.cloneNode(true)); }
    }

    function ouvrir(nom) {
      peupler();
      $$('[data-barre-cible]', panneau).forEach(function (el) {
        el.hidden = el.getAttribute('data-barre-cible') !== nom;
      });
      panneau.hidden = false;
      voile.hidden = false;
      requestAnimationFrame(function () {
        panneau.classList.add('est-ouvert');
        voile.classList.add('est-ouvert');
      });
      onglets.forEach(function (o) {
        o.setAttribute('aria-expanded', String(o.getAttribute('data-barre-onglet') === nom));
      });
      ouvert = nom;
    }

    function fermer() {
      panneau.classList.remove('est-ouvert');
      voile.classList.remove('est-ouvert');
      onglets.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      ouvert = null;
      setTimeout(function () { panneau.hidden = true; voile.hidden = true; }, 300);
    }

    onglets.forEach(function (o) {
      on(o, 'click', function () {
        var nom = o.getAttribute('data-barre-onglet');
        if (ouvert === nom) { fermer(); return; }
        ouvrir(nom);
      });
    });
    on(voile, 'click', fermer);

    on($('[data-barre-ajouter]', barre), 'click', function () {
      fermer();
      forme.requestSubmit();
    });

    /* Le bouton principal de la fiche pilote le libellé et l'état de la
       barre : un seul point de vérité, pas de second calcul de variante. */
    var principal = $('[data-ajouter]', forme);
    if (principal && window.MutationObserver) {
      var copie = $('[data-barre-ajouter] .scf-btn__libelle', barre);
      var syncro = function () {
        var lib = $('.scf-btn__libelle', principal);
        if (copie && lib) copie.textContent = lib.textContent;
        $('[data-barre-ajouter]', barre).disabled = principal.disabled;
      };
      new MutationObserver(syncro).observe(principal, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']
      });
      syncro();
    }
  }

  /* ---------- init ---------- */
  function demarrer(portee) {
    $$('[data-galerie]', portee || document).forEach(function (g) {
      initBascule(g);
      if (bureau()) initVignettes(g);
      initZoom(g);
    });
    initBarre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  } else {
    demarrer(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pdp]') || e.target.hasAttribute('data-pdp')) demarrer(e.target);
  });
})();
